import React from 'react';

export default function KnotDecoration({ className = '', size = 'md', invert = false }) {
  const sizes = {
    sm: 'w-24',
    md: 'w-40',
    lg: 'w-56',
  };

  return (
    <img
      src="/assets/inerva-knot.png"
      alt=""
      aria-hidden="true"
      className={`h-auto ${sizes[size] || sizes.md} ${invert ? 'brightness-[10]' : ''} ${className}`}
    />
  );
}
